import React from 'react'
import PropTypes from 'prop-types'
import { IconButton } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { SocialChat } from '@fs/zion-icon'
import { useLoggedOutOverlay } from '../../providers'

const ChatLoginButton = ({ ariaLabel, children, asComponent, chatRoute, query, ...props }) => {
  const { overlay } = useLoggedOutOverlay(chatRoute ? { showChat: chatRoute, tracking: 'Chat' } : query)
  const [t] = useTranslation()

  const Tag = asComponent || IconButton

  if (Tag === IconButton && !props.Icon) {
    props.Icon = SocialChat
  }

  return (
    <Tag
      aria-label="Chat"
      {...props}
      onClick={overlay.handleClick}
      title={ariaLabel}
      data-selector="chatLoginOverlayButton"
      linkName="Chat"
    >
      {children || t('help.overlay.chat.primary', 'Chat')}
    </Tag>
  )
}

export default ChatLoginButton

ChatLoginButton.propTypes = {
  ariaLabel: PropTypes.string,
  asComponent: PropTypes.elementType,
  chatRoute: PropTypes.string,
  query: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
}
